<template>
  <div class="sportFootballMatchActionsHeader">
    <div class="wrapper">
      <div class="open">
        <el-checkbox :indeterminate="indeterminate" v-model="checkAll"/>
      </div>
      <div class="buttons">
        <el-button plain @click="handleClickVar"><svgicon :name="'sport/football/match/var'" original /><span>Var</span></el-button>
        <el-button plain @click="handleClickNeutral" icon="el-icon-plus" class="neutral" />
        <el-popover class="timeout"
          placement="bottom"
          width="auto"
          trigger="click"
          popper-class="sportFootballMatchActionsHeader">
          <el-button plain type="primary" size="mini" @click="handleClickTimeOut">Arret du jeu</el-button>
          <el-button plain type="primary" size="mini" @click="handleClickRestart">Reprise du jeu</el-button>
          <el-button plain slot="reference"><svgicon :name="'sport/football/match/timeout'" original /></el-button>
        </el-popover>
      </div>
      <div class="filter">
        <el-button icon="el-icon-view" plain size="mini" type="primary" :disabled="true" />
      </div>
      <span class="count">
        {{ count }} / {{ countTotal }}
      </span>
    </div>
  </div>
</template>

<script>
import { stopwatch } from '@/helpers/format'
import { actionCategories } from '@/store/model/sport/football/ActionCategories'

export default {
  name: 'SportFootballMatchActionsHeader',
  props: {
    match: Object,
    statusFilter: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      styleLoaded: null
    }
  },
  computed: {
    actions () { return this.$store.getters['Sport/Football/Match/actions'](this.match?.id) },
    count () { return this.statusFilter ? this.actions.filter((action) => { return action.statusId === this.statusFilter }).length : this.countTotal },
    countTotal () { return this.actions.length },
    checkAll: {
      get () { return this.actionsOpen },
      set (value) { this.actions.forEach(action => { action.open = value }) }
    },
    indeterminate () { return this.actionsOpen === this.actionsClose },
    actionsOpen () { return Boolean(this.actions.find((action) => { return action.open === true })) },
    actionsClose () { return Boolean(this.actions.find((action) => { return action.open === false })) }
  },
  methods: {
    handleClickVar () {
      this.addAction(actionCategories.getVar)
    },
    handleClickNeutral () {
      this.addAction(actionCategories.getNeutral)
    },
    handleClickTimeOut () {
      this.addAction(actionCategories.getTimeOut)
    },
    handleClickRestart () {
      this.addAction(actionCategories.getRestart)
    },
    addAction (action) {
      const time = stopwatch(this.match.dateStart, this.$store.getters['Server/live'], this.match.statusId)
      const newAction = {
        matchId: this.match.id,
        statusId: this.match.statusId,
        date: this.$store.getters['Server/live'].toISOString(),
        active: 1,
        minute: time ? parseInt(time.split(':')[0]) + 1 : null
      }

      Object.assign(newAction, action.rules)
      if (action.rulesPost) {
        Object.assign(newAction, action.rulesPost)
      }

      this.$store.dispatch('Sport/Football/Match/postAction', newAction)
    }
  }
}
</script>

<style>
.sportFootballMatchActionsHeader{
  position:relative;
  flex:initial;
  box-sizing:border-box;
  height: 60px;
  background-color: var(--color-background-grey);
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.25);
  padding:10px;
  z-index:1;
}
.sportFootballMatchActionsHeader .wrapper{
  display: grid;
  height:100%;
  grid-template-columns: 55px 25px 60px 4fr 1fr 1fr;
  grid-gap: 0 4px;
  grid-template-areas: ". open buttons buttons buttons filter count";
  justify-items: stretch;
  white-space: nowrap;
}
.sportFootballMatchActionsHeader .wrapper > .open{
  grid-area: open;
  align-self: center;
}
.sportFootballMatchActionsHeader .wrapper > .buttons{
  grid-area: buttons;
  align-self: center;
}
.sportFootballMatchActionsHeader .wrapper > .filter{
  grid-area: filter;
  align-self: center;
}
.sportFootballMatchActionsHeader .wrapper > .count{
  grid-area: count;
  align-self: center;
  font-size:12px;
  color:var(--color-font-grey-light)
}

.sportFootballMatchActionsHeader .wrapper > .buttons button {
  grid-area: buttons;
  align-self: center;
  padding:6px;
  line-height:28px;
}
.sportFootballMatchActionsHeader .wrapper > .buttons button.neutral{
  width:42px;
}
.sportFootballMatchActionsHeader .wrapper > .buttons .timeout button{
  margin-left:10px;
  width:42px;
}
.sportFootballMatchActionsHeader .wrapper > .buttons .timeout button svg{
  fill:black;
  transition:0.5s fill ease;
}
.sportFootballMatchActionsHeader .wrapper > .buttons .timeout button:hover svg,
.sportFootballMatchActionsHeader .wrapper > .buttons .timeout button:active svg{
  fill:var(--color-primary)
}
.sportFootballMatchActionsHeader .wrapper > .buttons > button > span > span {
  margin: 0 20px
}
.sportFootballMatchActionsHeader .wrapper > .buttons > button svg {
  width:26px;
  height:26px
}
.sportFootballMatchActionsHeader .el-checkbox__input.is-checked .el-checkbox__inner,
.sportFootballMatchActionsHeader .el-checkbox__input.is-indeterminate .el-checkbox__inner{
  background-color: var(--color-background-grey-dark);
  border-color: var(--color-background-grey-dark);
}
.sportFootballMatchActionsHeader .el-checkbox__inner:hover{
  border-color: var(--color-background-grey-dark);
}
.sportFootballMatchActionsHeader.el-popover{
  background-color:white;
  padding:18px;
  text-align: center;
  height:auto;
}
.sportFootballMatchActionsHeader.el-popover button{
  position:relative;
  display:block;
  margin:0 auto
}
.sportFootballMatchActionsHeader.el-popover button + button{
  margin-top:11px;
}
</style>
